<template>
  <div>
    <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />
        <span class="title_text2">面试数据</span>
      </div>
      <div class="query_box">
        <span class="export_table" @click="export_click">
          <Icon type="ios-cloud-download-outline" />导出表格
        </span>
        <DatePicker
          format="yyyy/MM/dd"
          v-model="query_date"
          size="small"
          type="daterange"
          placement="bottom-end"
          placeholder="筛选日期"
          style="width: 200px"
          @on-change="date_picker_change"
        />
      </div>
    </div>

    <div class="data_div">
      <div class="card_main">
        <Spin fix v-if="loading"></Spin>

        <div class="count_card">
          <div>
            <CountUp
              :end="interview_data.yaoyue.length"
              :duration="4"
              ref="count"
              v-font="18"
            />
          </div>
          <div class="count_title">邀约</div>
        </div>
        <div class="count_card">
          <div>
            <CountUp
              :end="interview_data.mianshi.length"
              :duration="4"
              ref="count"
              v-font="18"
            />
          </div>
          <div class="count_title">面试</div>
        </div>
        <div class="count_card">
          <div>
            <CountUp
              :end="interview_data.mianshi_butongguo.length"
              :duration="4"
              ref="count"
              v-font="18"
            />
          </div>
          <div class="count_title">面试不通过</div>
        </div>
        <div class="count_card">
          <div>
            <CountUp
              :end="interview_data.mianshi_tongguo.length"
              :duration="4"
              ref="count"
              v-font="18"
            />
          </div>
          <div class="count_title">面试通过</div>
        </div>
        <div class="count_card">
          <div>
            <CountUp
              :end="interview_data.ruzhi.length"
              :duration="4"
              ref="count"
              v-font="18"
            />
          </div>
          <div class="count_title">入职</div>
        </div>
        <div class="count_card">
          <div>
            <CountUp
              :end="interview_data.lizhi.length"
              :duration="4"
              ref="count"
              v-font="18"
            />
          </div>
          <div class="count_title">离职</div>
        </div>
        <div class="count_card">
          <div>
            <CountUp
              :end="interview_data.zaizhi.length"
              :duration="4"
              ref="count"
              v-font="18"
            />
          </div>
          <div class="count_title">当天在职</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http, open_new_page,get_view_file_url } from "@/utils/http.js";

export default {
  name: "interview_data",
  data() {
    return {
      project_id: "",
      project_name: "",
      query_date: [],
      loading: false,
      interview_data: {
        yaoyue: [],
        mianshi: [],
        mianshi_butongguo: [],
        mianshi_tongguo: [],

        ruzhi: [],
        lizhi: [],
        zaizhi: [],
      },
    };
  },

  methods() {},
  methods: {
    export_click() {
      if (this.export_loading) {
        this.$Message.warning({
          content: "正在下载中，请不要多次点击",
          duration: 5,
        });
        return;
      }
      this.export_loading = true;
      this.$Message.info({
        content: "提交导出成功，下载中……",
        duration: 5,
      });
      var that = this;
      var obj = {
        project_id: this.project_id,
        start_time: this.query_date[0].getTime() / 1000,
        end_time: this.query_date[1].getTime() / 1000,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/export_data",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            var url = res.data.url;
            var object_name = res.data.object_name
            console.log(object_name)
            // open_new_page(url);
            get_view_file_url(object_name)
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          this.export_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
          this.export_loading = false;
        });
    },

    date_picker_change(e) {
      console.log(e);
      this.get_interview_data();
    },

    open(project_id, project_name) {
        console.log(111111112)
        console.log(project_id,project_name)
      this.project_id = project_id;
      this.project_name = project_name;

      var stamp1 = new Date(new Date().setHours(0, 0, 0, 0)); //获取当天零点的时间
      var stamp2 = new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000);
      this.query_date = [stamp1, stamp2];
      this.get_interview_data();
    },

    //获取面试数据
    get_interview_data() {
      var that = this;
      var obj = {
        project_id: this.project_id,
        start_time: this.query_date[0].getTime() / 1000,
        end_time: this.query_date[1].getTime() / 1000,
      };
      this.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/project_interview_data",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.interview_data = res.data.interview_data;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.title_text2 {
  font-weight: 600;
}
.export_table {
  font-size: 12px;
  color: #0466dd;
  font-weight: 300;
  margin-right: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  letter-spacing: 1px;
}

.title_text {
  margin: 0px 0px 0 0px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ececec;
  padding: 10px 10px 5px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 2px;
}

.card_main {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  position: relative;
}

.count_title {
  font-size: 13px;
  color: #333;
  margin-top: 5px;
}

.count_card {
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 130px;
  border: 1px solid #ececec;
  border-radius: 5px;
  background-color: #fff;
  text-align: center;
}

.data_div {
  border-radius: 5px;
}

.query_box {
  display: flex;
  justify-content: flex-end;
}
</style>
